import { app } from '../../app.module'
app
  // アカウントの低く評価グラフの表示
  .directive('accountDislike', () => {
    return {
      restrict: 'E',
      template: require('./account-dislike.pug')(),
    }
  })
